export default __webpack_public_path__ + "static/media/tail-usdc.3a1e7acc.svg";